module.exports = __webpack_public_path__ + "static/media/Sorghum11-12.f8668e72.PNG";